import { Table, Input, Button, Modal, DatePicker, Select } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import { utils, writeFile } from "xlsx";
import {comma} from "../../lib/util/numberUtil";
import { drSearchTypeCode } from "../../lib/util/codeUtil";
import SelectBox from "../../components/common/SelectBox";

const Search = Input.Search;
const { RangePicker } = DatePicker;
const now = new Date();

const DepositRequestList = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [type, setType] = useState(0);
    const [searchType, setSearchType] = useState("")
    const [selected, setSelected] = useState("ALL");
    const [searchText, setSearchText] = useState("");
    const [depositRequestList, setDepositRequestList] = useState([]);
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });
    // const dte = 1000000000;

    useEffect(() => {
        getDepositRequestList();
    },[date.end, pagination.current, pagination.pageSize, searchText, date.start]);

    const getDepositRequestList = async () => {
        const pageSize = pagination.pageSize;
        const pageNum = pagination.current;
        const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
        const res = await httpGet(httpUrl.depositRequestList, [ endDate, pageNum, pageSize, searchText, selected, date.start], {})
        if (!res) {
            console.log(`getListAsync failed. result: ${res.result}`);
            return;
        }
        setDepositRequestList(res.data.depositRequests);
        setPagination({
            ...pagination,
           current: res.data.currentPage,
            total: res.data.totalCount
        })
    };

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };

    const statusCode = {
        "REQUEST": "입금대기",
        "COMPLETE": "완료",
        "FAIL": "시간만료",
    }

    const columns = [
        {
            title: "거래번호",
            dataIndex: "idx",
            className: "column-center",
        },
        {
            title: "신청번호",
            dataIndex: "depositKey",
            className: "column-center",
        },
        {
            title: "일시",
            dataIndex: "createDate",
            className: "column-center",
            render: (data) => <div>{moment(data).format("YYYY-MM-DD HH:mm:ss")}</div>
        },
        // {
        //     title: "만료일시",
        //     dataIndex: "expireDate",
        //     className: "column-center",
        // },
        {
            title: "유저키",
            dataIndex: "userKey",
            className: "column-center",
        },
        {
            title: "주소",
            dataIndex: "address",
            className: "column-center",
            render: (data) => 
            <a
                className="alink"
                target='_blank'
                href={"https://bscscan.com/address/"+data}
            >
                {data}
            </a>
        },
        {
            title: "상품명(상품코드)",
            dataIndex: "productCode",
            className: "column-center",
        },
        {
            title: "신청금액(신청화폐)",
            dataIndex: "productPrice",
            className: "column-center",
            render: (data) => <div>{comma(data)}</div>
        },
        {
            title: "입금할수량(COIN)",
            dataIndex: "amount",
            className: "column-center",
            render: (data) => <div>{comma(data)}</div>
            // render: (data) => <div>{comma(data/dte)}</div>

        },
        {
            title: "실제입금수량(COIN)",
            dataIndex: "realAmount",
            className: "column-center",
            render: (data) => <div>{comma(data)}</div>
            // render: (data) => <div>{comma(data/dte)}</div>

        },
        {
            title: "상태",
            dataIndex: "status",
            className: "column-center",
            render: (data) => <div>{statusCode[data]}</div>
        },
    ];
    const onSearch = (value) => {
        setSearchText(value);
        getDepositRequestList();
    };

    const onSelect = (value) => {
        setSelected(value);
    };

    const reset =() =>{
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        setSearchText("")
        setSelected("ALL")
    };


    const changeDate =(type) =>{
    if (type ==='today'){
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    } else if (type === 'week'){
        setType(1)
        setDate({
            start: moment().add(-7, 'd').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else if (type === 'threeMonth'){
        setType(2)
        setDate({
            start:  moment().add(-3, 'M').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else{
        setType(3)
        setDate({
            start: moment('2023-01-01').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        }

    };

    const onChangeRangePicker = async (e, selectDate, value) => {
        setType(4)
        setDate({
            start: moment(selectDate[0]).format('YYYY-MM-DD'),
            end: moment(selectDate[1]).format('YYYY-MM-DD')
        })
    };


    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };

    const onDownload = () => {
    httpGet(
        httpUrl.depositRequestListExcel,
        [
            moment(date.end).add(1, 'd').format("YYYY-MM-DD"), searchText, selected, date.start
        ],
        {}
    ).then((res) => {
        const excelJson = parseExcelJson(res.data.depositRequests);
        const ws = utils.json_to_sheet(excelJson, { skipHeader: true });
        const wb = utils.book_new();
        // ws["!cols"] = [];
        // ws["!cols"][2] = { width: 20 };
        // ws["!cols"][3] = { width: 15 };
        // ws["!cols"][4] = { width: 20 };
        // ws["!cols"][5] = { width: 15 };
        // ws["!cols"][8] = { width: 20 };
        utils.book_append_sheet(wb, ws, "sheet1");
        writeFile(wb, "입금_신청_내역.xlsx");
    });
  };

  const parseExcelJson = (data) => {
    let result = [
      {
        idx: '거래번호',
        depositKey: '신청번호',
        createDate: '일시',
        userKey: '유저키',
        address:'주소',
        productCode:'상품명(상품코드)',
        productPrice:'신청금액(신청화폐)',
        amount:'입금할수량(COIN)',
        status:'상태'
        // throne2:'입금한수량(DTE)',
        // subCompany:'서브업체명',
        // email:'이메일',
        // phone:'휴대전화',
        // ip:'IP주소',
        // countryCode:'국가코드'
      },
    ];
    data.forEach((item) => {
      result.push({
        idx: item.idx,
        depositKey: item.depositKey,
        createDate: moment(item.createDate).format("YYYY-MM-DD HH:mm:ss"),
        userKey: item.userKey,
        address: item.address,
        productCode: item.productCode,
        productPrice: item.productPrice,
        amount: item.amount + `(Coin)`,
        status:statusCode[item.status]
        // expireDate: item.expireDate,
        // applyAmount: item.applyAmount +(item.applyAmount),
        // throne2: item.throne2 + `(DTE)`,
        // subCompany: item.subCompany,
        // email: item.email,
        // phone: item.phone,
        // ip: item.ip,
        // countryCode: item.countryCode,
      });
    });

    return result;
  };



    return (
        <div className="main">
                <div className="main-title">
                    입금 신청 내역
                </div>
                    <div className="top-bar">
                       <div id="selectBox">
                            <Button className={type === 0 && "active"} onClick={()=>changeDate('today')}>
                                금일
                            </Button>
                            <Button  className={type === 1 && "active"} onClick={()=>changeDate('week')}>
                                1주일
                            </Button>
                            <Button className={type === 2 && "active"} onClick={()=>changeDate('threeMonth')}>
                                3개월
                            </Button>
                            <Button className={type === 3 && "active"} onClick={()=>changeDate('all')}>
                                전체
                            </Button>
                            <p>
                            <RangePicker
                                style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                                locale={locale}
                                format={"YYYY-MM-DD"}
                                allowClear={false}
                                picker="date"
                                value={[
                                moment(date.start, "YYYY-MM-DD"),
                                moment(date.end, "YYYY-MM-DD"),
                                ]}
                                onChange={onChangeRangePicker}
                                disabledDate={disabledDate}
                            />
                            </p>
                             <SelectBox
                                name="searchType"
                                className="memo-select" 
                                style={{width:100}}
                                placeholder={drSearchTypeCode['ALL']}
                                code={Object.keys(drSearchTypeCode)}
                                codeString={drSearchTypeCode}
                                onChange={(value) => {onSelect(value)}}
                                value={selected}
                            />
                            <Input.Search
                                placeholder="검색어를 입력하세요"
                                className="search-input"
                                enterButton
                                allowClear
                                onSearch={onSearch}
                                value={searchText}
                                onChange={(e)=>{
                                    setSearchText(e.target.value.trim());
                                }}
                            />
                        </div>
                        <Button onClick={()=>reset()}>
                                초기화
                        </Button>
                    </div>
                   <div className="top-table">
                        <div className="top-table-container">
                                <div>
                                총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                                </div>
                                <div>
                                <Button className="download-btn"
                                    onClick={() => onDownload()}
                                > 
                                <div>
                                    <img src={excelPng} alt="" />다운로드
                                </div>
                                </Button>
                                </div>
                         </div>

                        <Table
                            rowKey={(record) => record.idx}
                            dataSource={depositRequestList}
                            columns={columns}
                            pagination={pagination}
                            onChange={handleTableChange}
                        />
                     </div>
        </div>
    );

}

export default DepositRequestList;
